import { Link, Outlet } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { SiteHeader } from "./SiteHeader";
import { Brand, useBrand, SHOW_SECTIONS } from "./Brand";

const SiteFooter = () => {
  const { categories, lang } = useSite();
  const { name, tagline } = useBrand();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#0B2A5B] text-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <Brand variant="footer" testId="footer-brand" />
        </div>
        <div className={`md:col-span-3 ${SHOW_SECTIONS ? "" : "hidden"}`}>
          <p className="text-[11px] uppercase tracking-[0.14em] text-blue-300 mb-3">Sections</p>
          <ul className="space-y-2 text-sm">
            {categories.map((c) => (
              <li key={c.id}><Link className="hover:text-white" to={`/category/${c.slug}`}>{lang === "ta" ? c.name_ta : c.name_en}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <p className="text-[11px] uppercase tracking-[0.14em] text-blue-300 mb-3">About</p>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-disclaimer-link" className="hover:text-white" to="/page/disclaimer">Disclaimer</Link></li>
            <li><Link data-testid="footer-copyright-link" className="hover:text-white" to="/page/copyright">Copyright</Link></li>
            <li><Link data-testid="footer-contact-link" className="hover:text-white" to="/page/contact">Contact us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-blue-900">
        <p data-testid="footer-copyright" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-blue-300">
          © {year} {name} · {tagline}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export const PublicLayout = () => (
  <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
    <SiteHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
  </div>
);
